import { render, staticRenderFns } from "./AccordianInformationBlock.vue?vue&type=template&id=4219acf9&"
import script from "./AccordianInformationBlock.vue?vue&type=script&lang=js&"
export * from "./AccordianInformationBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports